import type { SVGProps } from 'react'
const SvgSyCircleFilled = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width={24} height={24} {...props}>
		<path d="M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512" />
	</svg>
)
export default SvgSyCircleFilled
